export default {
    namespaced: true,
    state: {
      token: null,
      type: 'v3'
    },
    mutations: {
      setToken(state, payload) {
        state.token = payload.token;
        state.type = payload.type;
      },
    },
    actions: {
      setRecaptcha({ commit }, payload) {
        commit('setToken', payload);
      },
    },
    getters: {
      getToken(state) {
        return state.token;
      },
      getType(state) {
        return state.type;
      },
    },
  };
  